<template>
  <h-tour-dialog v-model="show" dark>
    <div v-if="finishing" class="text-center">
      <div class="text-h5 font-weight-bold mb-6" v-text="__('tour4Congrats')" />
      <v-btn
        v-if="! $page.props.auth.demo"
        depressed
        color="primary"
        class="mt-6"
        @click.stop="close()"
        v-text="__('tour4Continue')"
      />
      <div v-else>
        <div class="text-subtitle-1 ma-6" v-text="__('tour4Upgrade')" />
        <div class="text-h6 primary--text my-3" v-text="__('tour4Only')" />
        <div class="text-h5 font-weight-black white--text">{{ $store.state.purchase.price }} {{ __('tour4Euros') }}</div>
        <div class="text-body-2" v-text="__('tour4NoTax')" />
        <div class="mt-6">
          <v-btn
            depressed
            large
            color="primary"
            @click="purchase()"
            v-text="__('tour4StartNow')"
          />
        </div>
        <div class="mt-4">
          <v-btn
            text
            small
            class="text-none"
            @click.stop="close()"
            v-text="__('tour4NotNow')"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="text-center text-h4 font-weight-bold mb-6" v-text="__('tour2Title')" />
      <p class="text-h6" v-text="__('tour2Text')" />
      <div class="my-8 text-subtitle-1">
        <div class="ma-4">
          <v-icon left v-text="icons.coins" style="opacity:.8" />{{ __('tour2Charge') }}
        </div>
        <div class="ma-4">
          <v-icon left v-text="icons.edit" style="opacity:.8" />{{ __('tour2Modify') }}
        </div>
      </div>
    </div>
  </h-tour-dialog>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HTourDialog from './Dialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HTourDialog,
    },

    props: {
      value: {
        required: true,
        type: Boolean,
      },
      finishing: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      show: {
        get () {
          return this.value
        },
        set (v) {
          this.$emit('input', v)
        },
      },
    },

    methods: {
      purchase () {
        this.$store.dispatch('purchase/open')
        this.close()
      },
      close () {
        this.show = false
      },
    },
  }
</script>
